import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsManComponent } from './simple-icons-man.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsManComponent ],
    exports:      [ SimpleIconsManComponent ],
    bootstrap:    []
})
export class SimpleIconsManModule {}
